// extracted by css-extract-rspack-plugin
export default {"viewAllContainer":"_e383f4f8","viewAllHeading":"_2c906db7","viewAllButton":"_b6bf81c9"};